<nav class="navigation" [class.products-open]="isProductsOpen">
  <!-- MOBILE TOP BAR (visible < xl) -->
  <div class="nav-main nav-mobile">
    <button class="mobile-hamburger" (click)="openMobileMenu()" aria-label="Open menu">
      <img src="/assets/icons/menu.svg" alt="">
    </button>
    <a routerLink="/">
      <img src="/assets/imgs/Logo.png" alt="PixiePets" class="nav-logo">
    </a>
    <app-cart-dropdown></app-cart-dropdown>
  </div>

  <!-- MOBILE FULLSCREEN MENU OVERLAY -->
  @if (isMobileMenuOpen) {
    <div class="mobile-menu-overlay" (click)="closeMobileMenu()">
      <div class="mobile-menu" (click)="$event.stopPropagation()">

        <!-- ===== MAIN VIEW ===== -->
        @if (mobileMenuView === 'main') {
          <!-- Mobile Menu Header -->
          <div class="mobile-menu__header">
            <button class="mobile-menu__close" (click)="closeMobileMenu()" aria-label="Close menu">
              <i class="pi pi-times"></i>
            </button>
            <a routerLink="/" (click)="closeMobileMenu()">
              <img src="/assets/imgs/Logo.png" alt="PixiePets" class="nav-logo">
            </a>
            <app-cart-dropdown></app-cart-dropdown>
          </div>

          <!-- User Account Card (when logged in) -->
          @if (authService.currentUser$ | async; as user) {
            <div class="mobile-menu__user-card" (click)="navigateToClientPanel()">
              <app-avatar-initials
                [name]="user.full_name || user.name || ''"
                [avatarUrl]="user.avatar"
                [size]="48"
              />
              <div class="mobile-menu__user-info">
                <p class="mobile-menu__user-greeting">{{ 'landing.mobile_menu.hi' | translate }}, {{ user.name }}!</p>
                <p class="mobile-menu__user-subtitle">{{ 'client.navigation.account_settings' | translate }}</p>
              </div>
              <i class="pi pi-chevron-right mobile-menu__user-chevron"></i>
            </div>
          } @else {
            <!-- Join Banner (when not logged in) -->
            <div class="mobile-menu__join-banner" (click)="onMobileLoginClick()">
              <img src="/assets/imgs/neutral_1.png" alt="" class="mobile-menu__join-mascot">
              <div class="mobile-menu__join-content">
                <p class="mobile-menu__join-title">{{ 'landing.mobile_menu.join_title' | translate }}</p>
                <p class="mobile-menu__join-subtitle">{{ 'landing.mobile_menu.join_subtitle' | translate }}</p>
              </div>
            </div>
          }

          <!-- Mobile Menu Body (scrollable) -->
          <div class="mobile-menu__body">
            <!-- Products Section -->
            <h3 class="mobile-menu__section-title">{{ 'landing.menu.products' | translate }}</h3>
            <div class="mobile-menu__categories">
              @for (category of categoriesService.categories(); track category.id) {
                <a
                  class="mobile-menu__category-card"
                  [routerLink]="getCategoryUrl(category)"
                  (click)="closeMobileMenu()"
                >
                  <span class="mobile-menu__category-name">{{ category.name }}</span>
                  <span class="mobile-menu__category-media">
                    @if (category.image?.small) {
                      <img [src]="category.image?.small" [alt]="category.name" />
                    }
                    <i class="pi pi-chevron-right"></i>
                  </span>
                </a>
              }
            </div>

            <!-- Explore Section -->
            <h3 class="mobile-menu__section-title">{{ 'landing.mobile_menu.explore' | translate }}</h3>
            <div class="mobile-menu__links">
              <a class="mobile-menu__link" [routerLink]="howItWorksLink" (click)="closeMobileMenu()">
                {{ 'landing.menu.how_it_works' | translate }}
              </a>
              <a class="mobile-menu__link" [routerLink]="inspireLink" (click)="closeMobileMenu()">
                {{ 'landing.menu.inspire' | translate }}
              </a>
              <a class="mobile-menu__link" [routerLink]="blogLink" (click)="closeMobileMenu()">
                Blog
              </a>
            </div>

            <!-- Country / Language trigger -->
            @if (i18nService.supportedLangs.length > 0) {
              <div class="mobile-menu__lang">
                <button class="mobile-menu__lang-trigger" (click)="showCountryView()">
                  @for (lang of i18nService.supportedLangs; track lang.code) {
                    @if (lang.code === i18nService.getCurrentLang()) {
                      <img [src]="getFlagUrl(lang)" [alt]="lang.name" class="mobile-menu__lang-flag" />
                      <span class="mobile-menu__lang-label">{{ lang.name }}</span>
                    }
                  }
                  <i class="pi pi-chevron-right mobile-menu__lang-chevron"></i>
                </button>
              </div>
            }
          </div>
        }

        <!-- ===== COUNTRY VIEW ===== -->
        @if (mobileMenuView === 'country') {
          <div class="mobile-menu__header">
            <button class="mobile-menu__back" (click)="showMainView()" aria-label="Back">
              <i class="pi pi-arrow-left"></i>
            </button>
            <h2 class="mobile-menu__header-title">{{ 'landing.mobile_menu.country' | translate }}</h2>
            <div style="width: 40px;"></div>
          </div>

          <div class="mobile-menu__body">
            <div class="mobile-menu__country-list">
              @for (lang of i18nService.supportedLangs; track lang.code) {
                <button
                  class="mobile-menu__country-item"
                  [class.is-active]="lang.code === i18nService.getCurrentLang()"
                  (click)="selectMobileLanguage(lang)"
                >
                  <img [src]="getFlagUrl(lang)" [alt]="lang.name" class="mobile-menu__country-flag" />
                  <span class="mobile-menu__country-code">{{ lang.code | uppercase }}</span>
                  <span class="mobile-menu__country-name">{{ lang.name }}</span>
                  @if (lang.code === i18nService.getCurrentLang()) {
                    <i class="pi pi-check mobile-menu__country-check"></i>
                  }
                </button>
              }
            </div>
          </div>
        }

        <!-- ===== ACCOUNT VIEW ===== -->
        @if (mobileMenuView === 'account') {
          <div class="mobile-menu__header">
            <button class="mobile-menu__back" (click)="showMainView()" aria-label="Back">
              <i class="pi pi-arrow-left"></i>
            </button>
            <h2 class="mobile-menu__header-title">{{ 'client.account_menu.title' | translate }}</h2>
            <div style="width: 40px;"></div>
          </div>

          @if (authService.currentUser$ | async; as user) {
            <div class="mobile-menu__account-user">
              <app-avatar-initials
                [name]="user.full_name || user.name || ''"
                [avatarUrl]="user.avatar"
                [size]="56"
              ></app-avatar-initials>
              <div class="mobile-menu__account-user-info">
                <p class="mobile-menu__account-user-name">{{ user.full_name || user.name }}</p>
                <p class="mobile-menu__account-user-email">{{ user.email }}</p>
              </div>
            </div>
          }

          <div class="mobile-menu__account-divider"></div>

          <div class="mobile-menu__body">
            <div class="mobile-menu__account-nav">
              @for (item of accountMenuItems; track item.label) {
                <a class="mobile-menu__account-item" (click)="navigateFromAccount(item.route)">
                  <i [class]="item.icon"></i>
                  <span>{{ item.label | translate }}</span>
                </a>
              }
            </div>
          </div>

          <div class="mobile-menu__account-footer">
            <button class="mobile-menu__account-logout" (click)="onAccountLogout()">
              {{ 'client.account_menu.logout' | translate }}
            </button>
          </div>
        }

      </div>
    </div>
  }

  <!-- DESKTOP NAV (visible >= xl) -->
  <div class="nav-main nav-desktop nav-desktop-left">
    <a routerLink="/">
      <img src="/assets/imgs/Logo.png" alt="">
    </a>
    <a routerLink="/">{{ 'landing.menu.how_it_works' | translate }}</a>
    <span
      class="products-toggle"
      [class.active]="isProductsOpen"
      (mouseenter)="openProductsMenu()"
      (mouseleave)="scheduleCloseProductsMenu()"
    >
      <a [routerLink]="productsLink" >
        <span>{{ 'landing.menu.products' | translate }}</span>
        <i class="pi pi-chevron-down ml-2" [class.rotate]="isProductsOpen"></i>
      </a>
    </span>
    <a routerLink="/">{{ 'landing.menu.inspire' | translate }}</a>
    <a routerLink="blog">Blog</a>
  </div>
  <div class="nav-main nav-desktop nav-desktop-right">
    <app-cart-dropdown></app-cart-dropdown>
    <span>
      <app-user-avatar></app-user-avatar>
    </span>
    <span class="project-button-wrapper">
      <app-button customIconSrc="/assets/icons/magic-wand.svg" [shadow]="false" routerLink="project" fragment="top"
                  [label]="'landing.create_art' | translate"></app-button>
    </span>
    <app-lang-select></app-lang-select>
  </div>
  @if (isProductsOpen && categoriesService.categories().length > 0) {
    <div
      class="products-panel"
      (mouseenter)="openProductsMenu()"
      (mouseleave)="scheduleCloseProductsMenu()"
    >
      <div class="products-grid">
        @for (category of categoriesService.categories(); track category.id) {
          <a
            class="product-category-card"
            [routerLink]="getCategoryUrl(category)"
            (click)="closeProductsMenu()"
          >
            <div class="category-text">{{ category.name }}</div>
            <div class="category-media">
              <div class="category-media-image">
                @if (category.image?.small) {
                  <img [src]="category.image?.small" [alt]="category.name" />
                } @else {
                  <i class="pi pi-image"></i>
                }
              </div>
              <i class="pi pi-chevron-right"></i>
            </div>
          </a>
        }
      </div>
    </div>
  }
</nav>
